import * as React from 'react';
import { useController, useFormContext } from 'react-hook-form';

import TableEditableComponent from './table';
import { TableEditableComponentProps } from './type';

interface Props<T> extends Omit<TableEditableComponentProps<T>, 'name'> {
  name: string;
}

export default function TableInput<T = Record<string, any>>(props: Props<T>) {
  const { name, ...rest } = props;

  const { control } = useFormContext<any>();
  const { formState } = useController({ control, name });

  return (
    <TableEditableComponent {...rest} errors={formState.errors} name={name} />
  );
}
